import { GridViewStatusChipWebComponent } from './component/GridViewStatusChipWebComponent';

export { GridViewStatusChipWebComponent };
